import Regwall from './Regwall';

export default Regwall;
